export default [
  {
    path: "/pengamatan-opt/",
    component: () => import("@/pages/pengamatan-opt/pengamatan-opt-list.vue"),
    meta: {
      title: "Daftar Pengamatan OPT",
      allowedProvinsiSublevels: ["proteksi"],
    },
  },
  {
    path: "/pengamatan-opt/create",
    component: () => import("@/pages/pengamatan-opt/pengamatan-opt-form.vue"),
    meta: {
      title: "Tambah Pengamatan OPT",
      allowedProvinsiSublevels: ["proteksi"],
    },
  },
  {
    path: "/pengamatan-opt/detail/:id",
    component: () => import("@/pages/pengamatan-opt/pengamatan-opt-detail.vue"),
    meta: {
      title: "Detail Pengamatan OPT",
      allowedProvinsiSublevels: ["proteksi"],
    },
  },
  {
    path: "/pengamatan-opt/update/:id",
    component: () => import("@/pages/pengamatan-opt/pengamatan-opt-update.vue"),
    meta: {
      title: "Edit Pengamatan OPT",
      allowedProvinsiSublevels: ["proteksi"],
    },
  },
  {
    path: "/pengamatan-opt/import",
    component: () => import("@/pages/pengamatan-opt/pengamatan-opt-import.vue"),
    meta: {
      title: "Import Pengamatan OPT",
      allowedProvinsiSublevels: ["proteksi"],
    },
  },
];
